const storageFilters = {
    attendants: true,
    channels: true,
    future: true,
    status: true,
    group: true,
    tmr_email: true,
    nps: true,
    csat: true,
    reason: true,
    gda: true,
    in: true,
    tmain: true,
    out: true,
    tmaout: true,
    timepausefuture: true,
    timestatus: true
  };
  
  const initialState = localStorage.getItem("filters_manager_columns_colaborators") ? JSON.parse(localStorage.getItem("filters_manager_columns_colaborators")):storageFilters
  
  const columnsallcolaborators = (state = initialState, action) => {
      switch (action.type) {
        case 'CHANGE_COLUMNS_ALL_COLABORATORS':
          return {
                attendants: action.attendants,
                channels: action.channels,
                future: action.future,
                status: action.status,
                group: action.group,
                tmr_email: action.tmr_email,
                nps: action.nps,
                csat: action.csat,
                reason: action.reason,
                gda: action.gda,
                in: action.in,
                tmain: action.tmain,
                out: action.out,
                tmaout: action.tmaout,
                timepausefuture: action.timepausefuture,
                timestatus: action.timestatus
            }
        default:
          return state
      }
    }
    
    export default columnsallcolaborators
  